import { Capacitor } from '@capacitor/core';

export const WIDTH_CLASSNAME = 'mx-auto w-full lg:w-3/4 max-w-6xl';

export const TABLE = 'w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 table-fixed';
export const TABLE_THEAD = 'text-xs text-gray-700 uppercase bg-gray-200 dark:bg-gray-800 dark:text-gray-400';
export const TABLE_TBODY_TR =
  'odd:bg-gray-50 odd:dark:bg-gray-700 even:bg-gray-100 even:dark:bg-gray-600 border-b dark:border-gray-700 text-gray-900 dark:text-gray-200';
export const TABLE_TD = 'px-2 py-3';

// mobile constants
export const IS_MOBILE_APP = Capacitor.getPlatform() !== 'web';
export const IS_WEB_APP = Capacitor.getPlatform() === 'web';
export const IS_IOS_APP = Capacitor.getPlatform() === 'ios';
export const IS_ANDROID_APP = Capacitor.getPlatform() === 'android';

export const MODULE_URL = 'http://daytopper.local';
export const MODULE_FIRMWARE_VERSION = 20;
